import { render, staticRenderFns } from "./DropdownHeader.vue?vue&type=template&id=40aee422&"
import script from "./DropdownHeader.vue?vue&type=script&lang=js&"
export * from "./DropdownHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports